/** WebAuthn: huella o Face ID del propio dispositivo para desbloquear la app. */
const b64urlToBuf = (s) => {
  const pad = s.replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(pad + "=".repeat((4 - (pad.length % 4)) % 4));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

const bufToB64url = (buf) =>
  btoa(String.fromCharCode(...new Uint8Array(buf)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const biometricSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;

export const registerBiometric = async (accountKey, label) => {
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  const cred = await navigator.credentials.create({
    publicKey: {
      challenge,
      rp: { name: "Layer Engine" },
      user: {
        id: Uint8Array.from(accountKey, (c) => c.charCodeAt(0)),
        name: label || accountKey,
        displayName: label || accountKey,
      },
      pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
      authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required" },
      timeout: 60000,
      attestation: "none",
    },
  });
  return bufToB64url(cred.rawId);
};

export const unlockWithBiometric = async (credentialId) => {
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  const assertion = await navigator.credentials.get({
    publicKey: {
      challenge,
      allowCredentials: credentialId ? [{ type: "public-key", id: b64urlToBuf(credentialId) }] : [],
      userVerification: "required",
      timeout: 60000,
    },
  });
  return !!assertion;
};
